import React, { useEffect, useState } from 'react';
import { Stepper, Step, StepLabel, Typography } from '@mui/material';
import { headLineStyle } from '../../Layout/HeadLineStyle';
import FirstForm from './Forms/FirstForm';
import SecondForm from './Forms/SecondForm';
import ThirdForm from './Forms/ThirdForm';
import { FourthForm } from './Forms/FourthForm';
import { FifthForm } from './Forms/FifthForm';
import { FormSix } from './Forms/FormSix';
import HttpClient from '../../utils/HttpClient';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../UserAdd/Forms/form.css';

const FormOnedata = {
    "companyName": "",
    "companyTypeID": "",
    "companyTypeName": "",
    "gender": "",
    "personName": "",
    "designationID": "",
    "userType": "",
    "userTypeName": ""
}

const initProduct = {
    "name": "",
    "description": "",
    "image": ""
}
const initDoc = {
    "docName": "",
    "pdf": ""
}
const FormTwodata = {
    "companyDescription": "",
    "serviceID": [],
    "serviceName": [],
    "productData": [],
    "doc": [],
    "videoUrl": "",
}
const InitFormThreeData = {
    "telephoneNo": '',
    "mobileNo": '',
    'phone_code': '',
    "whatsappNo": '',
    'whats_code': '',
    "emailId": "",
    "websiteLink": "",
    "address": "",
    "location": "",
    "emirate": "",
    "country": "",
    "countryName": "",
    "locationLink": "",
}
const InitFormFourthData = {
    "banner": "",
    "profilePhoto": "",
}
const InitFormFifthData = {
    "userName": "",
    "password": "",
}
const InitFormSixData = {
    "dribbbleLink": "",
    "facebookLink": "",
    "instaLink": "",
    "linkedInLink": "",
    "youtubeLink": "",
    "neooBusinessPageLink": "",
}

function MultiStepForm() {
    //data from view field
    const location = useLocation()
    const [activeStep, setActiveStep] = useState(0);

    const [typeOfCompany, setTypeOfCompany] = useState(FormOnedata);
    //formtwo
    const [formTwoData, setFormTwoData] = useState(FormTwodata)
    //formthree
    const [formThreeData, setFormThreeData] = useState(InitFormThreeData)
    //fourth data
    const [formFourthData, setFormFourthData] = useState(InitFormFourthData)
    //fifth data
    const [formFifthData, setformFifthData] = useState(InitFormFifthData)
    //form six
    const [formSix, setformSix] = useState(InitFormSixData)
    // const dataform = { ...typeOfCompany, ...formTwoData, ...formThreeData, ...formFourthData, ...formFifthData, ...formSix }
    const navigate = useNavigate();

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSubmit = async (e) => {
        const baseUrl = process.env.REACT_APP_APPLICATION_URL || "https://www.neoosearch.com";
        e.preventDefault()
        const data = {
            profileTypeID: typeOfCompany?.userType,
            ...typeOfCompany,
            ...formTwoData, ...formThreeData, ...formFourthData, ...formFifthData, ...formSix,
            "userLink": baseUrl + "/Memberinvitation/" + formFifthData?.userName
        }

        const res = await HttpClient.requestData("user", "POST", data)
        if (res && res?.status) {
            toast.success("Form Submitted")
            setTypeOfCompany(FormOnedata)
            setFormTwoData(FormTwodata)
            setFormThreeData(InitFormThreeData)
            setFormFourthData(InitFormFourthData)
            setformFifthData(InitFormFifthData)
            setformSix(InitFormSixData)
            setActiveStep(0);
            Swal.fire({
                title: 'Success!',
                text: 'Would you like see the submitted data?',
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK'
            }).then((result) => {
                if (result.isConfirmed) {
                    // Route to another page using useNavigate
                    navigate('/recently-added-user', { state: res?.data?._id });

                }
            });
        }
        else {
            toast.error("something is wrong")
        }
    }
    //UPDATE DATA
    const handleEditSubmit = async (e) => {
        const baseUrl = process.env.REACT_APP_APPLICATION_URL || "https://www.neoosearch.com";
        e.preventDefault()
        const values = Object.values(formSix);
        if (values.includes("")) {
            toast.error("Empty Field detected");
            return; // Stop further execution
        }

        const data = {
            ...typeOfCompany,
            ...formTwoData, ...formThreeData, ...formFourthData, ...formFifthData, ...formSix,
            "userLink": baseUrl + "/Memberinvitation/" + formFifthData?.userName
        }
        const {
            userName,
            ...updatedData
        } = data;

        const res = await HttpClient.requestData("user/" + location?.state?._id, "PUT", updatedData)
        if (res && res?.status) {
            navigate("/view-user-data")
            toast.success("Form Submitted")
            setTypeOfCompany(FormOnedata)
            setFormTwoData(FormTwodata)
            setFormThreeData(InitFormThreeData)
            setFormFourthData(InitFormFourthData)
            setformFifthData(InitFormFifthData)
            setformSix(InitFormSixData)
            setActiveStep(0);

        }
        else {
            toast.error("something is wrong")
        }
    }

    //update nonmember to member
    //UPDATE DATA
    const handleUpdateNonmember = async (e) => {
        const baseUrl = process.env.REACT_APP_APPLICATION_URL || "https://www.neoosearch.com";
        e.preventDefault()
        // const { emailId, ...newFormThreeData } = formThreeData;
        // const { password, userName } = formFifthData;
        const values = Object.values(formSix);
        if (values.includes("")) {
            toast.error("Empty Field detected");
            return; // Stop further execution
        }

        const data = {
            ...typeOfCompany, ...formTwoData, ...formThreeData, ...formFourthData, "userName": formFifthData?.userName, ...formSix,
            "userLink": baseUrl + "/Memberinvitation/" + formFifthData?.userName
        }

        const res = await HttpClient.requestData("upgrade-nonmem/" + location?.state?._id, "POST", data)
        if (res && res?.status) {
            navigate("/view-user-data")
            toast.success("Form Submitted")
            setTypeOfCompany(FormOnedata)
            setFormTwoData(FormTwodata)
            setFormThreeData(InitFormThreeData)
            setFormFourthData(InitFormFourthData)
            setformFifthData(InitFormFifthData)
            setformSix(InitFormSixData)
            setActiveStep(0);

        }
        else {
            toast.error("something is wrong")
        }
    }
    const steps = ['Step 1', 'Step 2', 'Step 3', 'Step 4', 'Step 5', 'Step 6'];

    const getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return <FirstForm
                    onNext={handleNext}
                    typeOfCompany={typeOfCompany}
                    setTypeOfCompany={setTypeOfCompany} />;
            case 1:
                return <SecondForm
                    initProduct={initProduct}
                    initDoc={initDoc}
                    onNext={handleNext}
                    onBack={handleBack}
                    formTwoData={formTwoData}
                    setFormTwoData={setFormTwoData}
                    CompanyID={typeOfCompany.companyTypeID}
                />;
            case 2:
                return <ThirdForm
                    onNext={handleNext}
                    onBack={handleBack}
                    InitFormThreeData={InitFormThreeData}
                    formThreeData={formThreeData}
                    setFormThreeData={setFormThreeData}
                    location={location} />;

            case 3:
                return <FourthForm
                    onNext={handleNext}
                    onBack={handleBack}
                    formFourthData={formFourthData}
                    setFormFourthData={setFormFourthData}
                />
            case 4:
                return <FifthForm
                    onNext={handleNext}
                    onBack={handleBack}
                    formThreeData={formThreeData}
                    formFifthData={formFifthData}
                    setformFifthData={setformFifthData}
                    location={location}
                />
            case 5:
                return <FormSix
                    handleSubmit={handleSubmit}
                    handleEditSubmit={handleEditSubmit}
                    handleUpdateNonmember={handleUpdateNonmember}
                    onBack={handleBack}
                    formSix={formSix}
                    setformSix={setformSix}
                    location={location}
                />
            default:
                return 'Unknown stepIndex';
        }
    };

    useEffect(() => {
        if (location?.state) {
            setTypeOfCompany({
                companyName: location?.state?.companyName,
                companyTypeID: location?.state?.companyTypeID,
                companyTypeName: location?.state?.companyTypeName,
                gender: location?.state?.gender,
                personName: location?.state?.personName,
                designationID: location?.state?.designationID,
                userType: location?.state?.userType,
                userTypeName: location?.state?.userTypeName
            });
            const data = location?.state?.productData?.map((item, i) => {
                return item;
            })
            const dataDoc = location?.state?.doc?.map((item, i) => {
                return item;
            })
            setFormTwoData({
                "companyDescription": location?.state?.companyDescription,
                "serviceID": location?.state?.serviceID,
                "serviceName": location?.state?.serviceName,
                "productData": data,
                "doc": dataDoc,
                "videoUrl": location?.state?.videoUrl,
            })
            setFormThreeData({
                "telephoneNo": location?.state?.telephoneNo,
                "mobileNo": location?.state?.mobileNo,
                "whatsappNo": location?.state?.whatsappNo,
                "emailId": location?.state?.emailId,
                "websiteLink": location?.state?.websiteLink,
                "address": location?.state?.address,
                "location": location?.state?.location,
                "locationLink": location?.state?.locationLink,
                "emirate": location?.state?.emirate,
                "country": location?.state?.countryID,
                "countryName": location?.state?.countryName,
                'phone_code': location?.state?.phone_code,
                'whats_code': location?.state?.whats_code,
            })
            setFormFourthData({
                "banner": location?.state?.banner,
                "profilePhoto": location?.state?.profilePhoto,
            })
            setformFifthData({
                "userName": location?.state?.userName,
                "password": location?.state?.passwordView
            })
            setformSix({
                "dribbbleLink": location?.state?.dribbbleLink,
                "facebookLink": location?.state?.facebookLink,
                "instaLink": location?.state?.instaLink,
                "linkedInLink": location?.state?.linkedInLink,
                "youtubeLink": location?.state?.youtubeLink,
                "neooBusinessPageLink": location?.state?.neooBusinessPageLink
            })
        }
    }, [location]); // Ensure useEffect runs when location changes

    return (
        <div className="d-flex justify-content-end">

            <div className="form-header">
                <section className="piechartsBox_area">
                    {!location?.state ? <div
                        style={headLineStyle}
                        className="page-headline"
                    >
                        Add User
                    </div> : <div
                        style={headLineStyle}
                        className="page-headline"
                    >
                        Update User
                    </div>}
                    <div>
                        <div>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </div>
                        <div>
                            {activeStep === steps.length ? (
                                <div>
                                    <Typography>All steps completed</Typography>

                                </div>
                            ) : (
                                <div>
                                    <Typography>{getStepContent(activeStep)}</Typography>

                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default MultiStepForm;
